// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__vXmL8","title":"ClientReferral_title__31sG6","itemText":"ClientReferral_itemText__kZDXp"};